// themes.js
export const kuroirTheme = {
  base: "vs",
  inherit: true,
  rules: [
    { token: "comment", foreground: "AAAAAA", fontStyle: "italic" },
    { token: "keyword", foreground: "804000", fontStyle: "bold" },
    { token: "string", foreground: "008000" },
    { token: "number", foreground: "0000FF" },
    { token: "identifier", foreground: "333333" },
  ],
  colors: {
    "editor.background": "#e4e3deff",
    "editor.foreground": "#000000",
    "editorCursor.foreground": "#000000",
    "editor.lineHighlightBackground": "#F2F0E6",
    "editorLineNumber.foreground": "#A0A0A0",
    "editor.selectionBackground": "#C9D0D9",
  },
};

export const blackboardTheme = {
  base: "vs-dark",
  inherit: true,
  rules: [
    { token: "comment", foreground: "7C7C7C" },
    { token: "keyword", foreground: "96CBFE", fontStyle: "bold" },
    { token: "string", foreground: "A8FF60" },
    { token: "number", foreground: "FF73FD" },
    { token: "identifier", foreground: "FFFFFF" },
  ],
  colors: {
    "editor.background": "#353434ff",
    "editor.foreground": "#FFFFFF",
    "editorCursor.foreground": "#FFFFFF",
    "editor.lineHighlightBackground": "#3e3e3eff",
    "editorLineNumber.foreground": "#888888",
    "editor.selectionBackground": "#000000ff",
  },
};
